import { useOpenWithFaireApplicationStatus } from "@faire/deprecated-retailer-visitor-shared/stores/domain/OpenWithFaire/useOpenWithFaireApplicationStatus";
import { IRetailerLaunchWithFaire } from "@faire/web-api--source/indigofair/data/IRetailerLaunchWithFaire";

export enum OwFTier {
  NO_TIER = "NO_TIER",
  TIER_1 = "TIER_1",
}

/**
 * Used to determine which tier of Open with Faire form the retailer should see
 * Tier 1 is for retailers that are already IDV confirmed
 * Tier 2 is the general purpose form
 * Tier 3 is for retailers that discovered Faire through an
 * Open with Faire marketing channel
 */
export const useOwFIDVTierLogic = () => {
  const { applicationType } = useOpenWithFaireApplicationStatus();

  const isTier1 =
    applicationType === IRetailerLaunchWithFaire.ApplicationType.IDV_CONFIRMED;

  let activeTier: OwFTier = OwFTier.NO_TIER;
  if (isTier1) {
    activeTier = OwFTier.TIER_1;
  }

  const isAnyTierActive = activeTier !== OwFTier.NO_TIER;

  return {
    isAnyTierActive,
    activeTier,
  };
};
